import {connect} from 'react-redux';
import {List} from 'immutable';

import {
  loadResourceTag,
  updateResourceTag,
  createResourceTag,
  deleteResourceTag,
  resourceTagFormDestroy
} from '../../../../../state/modules/resourceTags/actions';
import {sendMessage} from '../../../../../state/actions';
import ResourceTagForm from '../components/ResourceTagForm';

const inputs = List([
  'label',
  'status'
]);

const mapStateToProps = (state, ownProps) => {

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['resourceTags', ownProps.id, val], '');
    errors[val] = state.resourceTags.getIn(['form', 'errors', val]);
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach(x => {
    if (['status', 'rating'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  return {
    isLoading: state.resourceTags.get('isLoading'),
    isSubmitting: state.resourceTags.getIn(['form', 'isSubmitting']),
    success: state.resourceTags.getIn(['form', 'success']),
    created_id: state.resourceTags.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['resourceTags', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['resourceTags', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadResourceTag(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateResourceTag(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createResourceTag(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteResourceTag(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(resourceTagFormDestroy(formState));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const ResourceTagFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceTagForm);

export default ResourceTagFormContainer;
